module.exports = __webpack_public_path__ + "img/social.d2cf05c.svg";